module.exports = __webpack_public_path__ + "static/img/3.af68848.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/eng/3.png
// module id = N2YS
// module chunks = 0